import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { movies } from "@/mocks/movies";

const slides = movies.slice(0, 4);

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const current = slides[active];

  return (
    <section className="relative h-[520px] md:h-[640px] w-full overflow-hidden">
      {slides.map((slide, idx) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${idx === active ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={slide.cover}
            alt={`${slide.title}（${slide.year}） - 色即是空`}
            title={`${slide.title} ${slide.year}`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-primary-950/20"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/70 via-transparent to-transparent"></div>

      <div className="relative z-10 h-full w-full max-w-[1280px] mx-auto px-4 md:px-6 flex flex-col justify-end pb-16 md:pb-20">
        <div className="max-w-xl">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label mb-4 whitespace-nowrap">
            {current.type === "movie" ? "热门电影" : "热门剧集"} · {current.year}
          </span>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
            {current.title}
          </h1>
          <p className="text-background-100 text-sm md:text-base leading-relaxed mb-6 line-clamp-3">
            {current.summary}
          </p>
          <div className="flex items-center gap-3 flex-wrap">
            <button
              onClick={() => navigate(`/detail/${current.id}`)}
              className="px-6 py-3 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-label cursor-pointer whitespace-nowrap transition-colors"
            >
              查看详细解析
            </button>
            <span className="flex items-center gap-1 text-background-50 text-sm">
              <i className="ri-star-fill text-accent-400"></i>
              {current.rating}
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:right-10 z-10 flex items-center gap-2">
        {slides.map((s, idx) => (
          <button
            key={s.id}
            onClick={() => setActive(idx)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              idx === active ? "w-8 bg-accent-500" : "w-4 bg-background-50/50"
            }`}
            aria-label={`切换到第${idx + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}